import { Phone, MessageCircle, MapPin, Clock } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import MapSection from "@/components/MapSection";
import {
  BRAND,
  PHONE_DISPLAY,
  PHONE_TEL,
  WHATSAPP_DISPLAY,
  WA_LINK,
} from "@/constants/site";

const INFO = [
  {
    icon: Clock,
    title: "Orari",
    lines: ["Lun–Ven 8:00–19:00", "Sabato 9:00–13:00"],
  },
  {
    icon: MapPin,
    title: "Sede",
    lines: [BRAND.address, "Su appuntamento"],
  },
];

export default function Contatti() {
  return (
    <main data-testid="contatti-page">
      <section className="bg-[#F7F5F0] pb-20 pt-36 sm:pt-44">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal>
            <Overline>Contatti</Overline>
            <h1 className="mt-4 max-w-2xl font-serif text-4xl font-semibold tracking-tight text-[#1A1918] sm:text-5xl lg:text-6xl">
              Parliamone
              <span className="italic text-[#C85A32]"> di persona.</span>
            </h1>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-[#6E6A64] md:text-lg">
              Niente moduli complicati: chiamaci o scrivici su WhatsApp e
              fissiamo subito il sopralluogo gratuito.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#F7F5F0] pb-24 sm:pb-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="grid gap-4 md:grid-cols-2">
            <Reveal>
              <a
                data-testid="contact-call-card"
                href={PHONE_TEL}
                className="group block h-full rounded-2xl bg-[#C85A32] p-9 text-[#FAF8F5] transition-[transform,background-color] duration-300 hover:-translate-y-1 hover:bg-[#A8481F] sm:p-11"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#FAF8F5]/15">
                  <Phone size={20} />
                </span>
                <p className="mt-8 font-mono text-xs uppercase tracking-[0.25em] text-[#FAF8F5]/70">
                  Telefono
                </p>
                <p className="mt-2 font-serif text-3xl font-semibold tracking-tight sm:text-4xl">
                  {PHONE_DISPLAY}
                </p>
                <p className="mt-4 text-sm text-[#FAF8F5]/75">
                  Risposta immediata negli orari di ufficio.
                </p>
              </a>
            </Reveal>

            <Reveal delay={0.12}>
              <a
                data-testid="contact-whatsapp-card"
                href={WA_LINK}
                target="_blank"
                rel="noreferrer"
                className="group block h-full rounded-2xl bg-[#161514] p-9 text-[#FAF8F5] transition-[transform,background-color] duration-300 hover:-translate-y-1 hover:bg-[#22201E] sm:p-11"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#FAF8F5]/10">
                  <MessageCircle size={20} />
                </span>
                <p className="mt-8 font-mono text-xs uppercase tracking-[0.25em] text-[#B88E4C]">
                  WhatsApp
                </p>
                <p className="mt-2 font-serif text-3xl font-semibold tracking-tight sm:text-4xl">
                  {WHATSAPP_DISPLAY}
                </p>
                <p className="mt-4 text-sm text-[#FAF8F5]/65">
                  Inviaci foto e misure: ti rispondiamo con una prima stima.
                </p>
              </a>
            </Reveal>
          </div>

          <div className="mt-4 grid gap-4 md:grid-cols-2">
            {INFO.map((info, i) => (
              <Reveal key={info.title} delay={0.1 * i}>
                <div
                  data-testid={`contact-info-${info.title.toLowerCase()}`}
                  className="flex items-start gap-5 rounded-2xl border border-[#1A1918]/10 bg-[#EFECE6] p-8"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#C85A32]/15 text-[#C85A32]">
                    <info.icon size={18} />
                  </span>
                  <div>
                    <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#6E6A64]">
                      {info.title}
                    </p>
                    {info.lines.map((l) => (
                      <p key={l} className="mt-2 text-sm font-medium text-[#1A1918]">
                        {l}
                      </p>
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <MapSection light />
    </main>
  );
}
